"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "pop-certificate-detail",
  components: {},
  props: {},
  data: function data() {
    return {
      isShow: false,
      resolve: null,
      reject: null,
      formData: {
        id: "",
        uid: "",
        certId: "",
        phone: "",
        thumb: ""
      },
      rules: {
        phone: [{
          required: true,
          message: "请输入手机号",
          trigger: "blur"
        }],
        thumb: [{
          required: true,
          message: "请上传证书照片",
          trigger: "change"
        }]
      }
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.resolve = null;
    this.reject = null;
  },
  watch: {},
  methods: {
    clearForm: function clearForm() {
      this.formData.certId = "";
      this.formData.id = "";
      this.formData.phone = "";
      this.formData.thumb = "";
      this.formData.uid = "";
    },
    // 打开弹窗
    openPop: function openPop(data) {
      var _this2 = this;
      this.clearForm();
      if (data) {
        this.formData.certId = data.certId || "";
        this.formData.id = data.id || "";
        this.formData.phone = data.phone || "";
        this.formData.thumb = data.thumb || "";
        this.formData.uid = data.user.uid;
      }
      this.isShow = true;
      return new Promise(function (re, rj) {
        _this2.resolve = re;
        _this2.reject = rj;
      });
    },
    // 关闭弹窗
    closePop: function closePop() {
      this.isShow = false;
      this.resolve([false, null]);
    },
    // 点击商品图
    addThumb: function addThumb() {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.formData.thumb = img[0].sattDir;
      }, "1", 'content');
    },
    delThumb: function delThumb() {
      this.formData.thumb = "";
    },
    // 保存
    onSubmit: function onSubmit() {
      var _this3 = this;
      this.$refs['证书门槛设置表单'].validate(function (valid) {
        if (!valid) return;
        if (_this3.formData.certId == "") {
          (0, _user.addCertificateApi)({
            phone: _this3.formData.phone,
            thumb: _this3.formData.thumb
          }).then(function (res) {
            _this3.$message.success("添加成功");
            _this3.isShow = false;
            _this3.resolve([true, _this3.formData]);
          });
        } else {
          (0, _user.updateCertificateApi)(_this3.formData).then(function (res) {
            _this3.$message.success("更新成功");
            _this3.isShow = false;
            _this3.resolve([true, _this3.formData]);
          });
        }
      });
    }
  }
};